"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_hook_form_1 = require("react-hook-form");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const customerAccountContext_1 = require("../../../contexts/customerAccountContext");
const constants_1 = require("../../../constants");
const Button_1 = require("../../common/Button");
const feedbackContext_1 = require("../../../contexts/feedbackContext");
function InventoryCard() {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const [formGlobalErrorMessage, setFormGlobalErrorMessage] = (0, react_1.useState)();
    const { addAlert } = (0, react_1.useContext)(feedbackContext_1.FeedbackContext);
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { currentUser } = customerAccountContext;
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const useFormMethods = (0, react_hook_form_1.useForm)({
        mode: "onBlur",
    });
    (0, react_1.useEffect)(() => {
        if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.inventoryEmail) {
            useFormMethods.setValue("email", currentUser === null || currentUser === void 0 ? void 0 : currentUser.inventoryEmail);
            useFormMethods.setValue("isSubscribed", true);
        }
        else {
            useFormMethods.setValue("email", "");
            useFormMethods.setValue("isSubscribed", false);
        }
    }, [currentUser]);
    function isValidEmail(email) {
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegex.test(email);
    }
    const onSubmit = (formData) => {
        setFormGlobalErrorMessage(undefined);
        const newInventoryEmail = formData.isSubscribed ? formData.email : "";
        if (isDataValid(formData)) {
            return customerAccountContext.actions.informations
                .updateCustomerInventoryEmailDocument({ inventory_email: newInventoryEmail })
                .then(() => {
                addAlert({
                    message: t("global.success.changeSubscription"),
                    status: "success",
                });
            })
                .catch((error) => {
                if (error.status != "success") {
                    setFormGlobalErrorMessage(t(boutik_gatsby_plugin_components_1.FormInput.FormValidation.getMagentoErrorTranslationKey(currentLocale, error.message)));
                }
            });
        }
        else {
            setFormGlobalErrorMessage(t("customerAccount.myToolbox.card.inventory.errors.needEmail"));
        }
    };
    const isDataValid = (formData) => {
        return (formData.isSubscribed && formData.email != "" && isValidEmail(formData.email)) || formData.isSubscribed != true;
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-my-toolbox-flux-card-container" },
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, useFormMethods),
            react_1.default.createElement("h3", null, t("customerAccount.myToolbox.card.inventory.title")),
            react_1.default.createElement("form", { className: "boutik-customer-account-my-toolbox-flux-card-form", onSubmit: useFormMethods.handleSubmit(onSubmit) },
                react_1.default.createElement("p", { className: "boutik-customer-account-my-toolbox-flux-error-message" }, formGlobalErrorMessage),
                react_1.default.createElement("div", { className: "section-header" },
                    react_1.default.createElement("div", { className: "boutik-customer-account-my-toolbox-flux-card" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("span", { className: "boutik-customer-account-my-toolbox-flux-card-description" }, t("customerAccount.myToolbox.card.inventory.description"))),
                            react_1.default.createElement("div", { className: "boutik-customer-account-flux-form-email-label" },
                                react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.subscriptionEmailValidation(currentLocale), label: t("customerAccount.myToolbox.card.inventory.labelEmail"), property: "email" })),
                            react_1.default.createElement("label", { className: "boutik-customer-account-form-text-input-label boutik-customer-account-flux-form-checkbox-label" },
                                react_1.default.createElement("input", Object.assign({ className: "boutik-customer-account-form-checkbox-input", type: "checkbox" }, useFormMethods.register("isSubscribed"))),
                                t("customerAccount.myToolbox.card.inventory.labelCheckbox"))))),
                react_1.default.createElement(Button_1.Button, { isLoading: useFormMethods.formState.isSubmitting, isSubmitButton: true, label: "customerAccount.myToolbox.card.inventory.buttonText", classNamePrefix: "boutik-customer-account-flux-form-submit" })))));
}
exports.default = InventoryCard;
//# sourceMappingURL=InventoryCard.js.map